import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const pains = ['Te despiertas cansada aunque dormiste suficiente', 'Has hecho mil dietas y siempre vuelves al mismo punto', 'Sabes QUÉ hacer pero no CÓMO sostenerte', 'Tu cuerpo cambió y no sabes cómo reconectarte con él', 'Comes "bien" a veces pero sin estructura real', 'Sientes que tu mente y tu cuerpo no están sincronizados'];
export function PainAgitation() {
  return <section className="py-24 bg-cream relative" data-id="element-207">
      <div className="max-w-4xl mx-auto px-6" data-id="element-208">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-209">
          <h2 className="font-serif text-3xl md:text-5xl mb-6 text-[#0D1B3E]" data-id="element-210">
            ¿Te sientes identificada con alguna de estas?
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-211"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-16" data-id="element-212">
          {pains.map((pain, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="flex items-start gap-4 bg-white p-6 rounded-2xl shadow-sm border border-navy/5 hover:shadow-md transition-shadow" data-id="element-213">
              <div className="flex-shrink-0 mt-1" data-id="element-214">
                <XCircle className="w-6 h-6 text-red-500" data-id="element-215" />
              </div>
              <p className="text-navy/80 font-medium text-lg leading-snug" data-id="element-216">
                {pain}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="text-center max-w-2xl mx-auto" data-id="element-217">
          <p className="text-xl md:text-2xl text-navy/70 font-serif italic leading-relaxed" data-id="element-218">
            "No es falta de voluntad, es falta de un sistema que se adapte a ti
            y no al revés. Mereces sentirte bien en tu cuerpo sin que sea un
            castigo."
          </p>
        </motion.div>
      </div>
    </section>;
}